import { MainCard } from '@armhr/ui';
import {
  Close as CloseIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';
import {
  Box,
  IconButton,
  Stack,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

const W4ReminderCard: React.FC = () => {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(true);

  const isJanuary = new Date().getMonth() === 0;

  if (!isJanuary || !isVisible) {
    return null;
  }

  return (
    <MainCard
      border={false}
      sx={{
        transition: 'all 0.3s ease-in-out',
        background: alpha(theme.palette.primary.light, 0.1),
        borderRadius: 4,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <IconButton
        size="small"
        onClick={() => setIsVisible(false)}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          borderRadius: 4,
          color: 'text.secondary',
          zIndex: 1,
          '&:hover': {
            bgcolor: 'white',
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="flex-start">
          {/* Hero Icon - Compact Version */}
          <Box
            sx={{
              position: 'relative',
              display: 'inline-flex',
              flexShrink: 0,
              mt: 0.5,
            }}
          >
            <DescriptionIcon
              sx={{
                fontSize: 48,
                color: alpha(theme.palette.primary.main, 0.2),
              }}
            />
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                top: '45%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontWeight: 900,
                fontSize: '0.75rem',
                color: 'primary.main',
              }}
            >
              W-4
            </Typography>
          </Box>

          <Box sx={{ pr: 3 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              W-4 Federal Exempt Status Reminder
            </Typography>
            <Typography variant="body1">
              If you wish to elect federal exempt status in 2026, you must
              complete a new W-4 form to claim exemption no later than{' '}
              <strong>February 15, 2026</strong>. If you have not completed a
              new W4 form to claim exempt from federal withholding by February
              15, 2026, your W4 status will be reset to Single, claiming zero
              for the 2026 tax year.
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </MainCard>
  );
};

export default W4ReminderCard;
